// removed by extract-text-webpack-plugin
module.exports = {"waterWave":"antd-pro-charts--water-wave-waterWave","text":"antd-pro-charts--water-wave-text","waterWaveCanvasWrapper":"antd-pro-charts--water-wave-waterWaveCanvasWrapper"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/WaterWave/index.less
// module id = 605
// module chunks = 0